import i18next from 'i18next';

import connectedStore from '../../store/connected-store';
import getLocale from '../../i18n/selectors/locale';
import getExtensionI18nextNamespace from './get-extension-i18next-namespace';

const getTranslationFunction = (extensionSlug) => {
  const store = connectedStore.get();
  const locale = getLocale(store.getState());
  const namespace = getExtensionI18nextNamespace(extensionSlug);
  return i18next.getFixedT(locale, namespace);
};

export default getTranslationFunction;
